import type { ResultOf } from '@graphql-typed-document-node/core';

import { ThirdPartyTypeEnum, graphql } from '@e-socna/data-layer';
import { EMPTY_ARRAY, EMPTY_STRING } from '@e-socna/empty';

import { generateId } from '../../../../utils/generate-id.util';

import { ThirdPartyFormTab } from '../../enums/tab.enum';

import { ThirdPartiesSelectionFormStep } from '../Selection';
import type {
  UniqueIdMaybeEmptyFieldValue,
  UniqueUsageMaybeEmptyFieldValue,
} from '../Selection/types/field-value.type';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

const enrichValue = (id: UniqueIdMaybeEmptyFieldValue) =>
  !id
    ? null
    : {
        _id: generateId(),
        personId: id,
        functions: EMPTY_ARRAY,
      };

const getId = (membership: UniqueUsageMaybeEmptyFieldValue) =>
  !membership ? EMPTY_STRING : (membership as Membership).personId;

export const ThirdPartyForm_OrganizationMembershipsStep_Organization_Fragment =
  graphql(`
    fragment ThirdPartyForm_OrganizationMembershipsStep_Organization_Fragment on Organization {
      activeMemberships {
        _id
        personId
        functions
        contextualRoleIds
        representativeTypeIds
      }
    }
  `);

type Membership = ResultOf<
  typeof ThirdPartyForm_OrganizationMembershipsStep_Organization_Fragment
>['activeMemberships'][number];

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
  readonly setHasMemberships: (hasMemberships: boolean) => void;
}

export const ThirdPartyOrganizationMembershipsFormStep = ({
  isInternal,
  setHasMemberships,
}: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdPartiesSelectionFormStep
      enrichValue={enrichValue}
      fieldName="activeMemberships"
      getId={getId}
      id={ThirdPartyFormTab.OrganizationMemberships}
      initialGridState={initialGridState}
      isInternal={isInternal}
      kind={ThirdPartyTypeEnum.Person}
      setIsFieldUsed={setHasMemberships}
    />
  );
};
